var cov_1theuk0zai = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Textarea/index.tsx",
      hash = "74ab8bc4662bbc99839384a2d66d02e58cb8653e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Textarea/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 14
        },
        end: {
          line: 23,
          column: 1
        }
      },
      "1": {
        start: {
          line: 14,
          column: 38
        },
        end: {
          line: 14,
          column: 43
        }
      },
      "2": {
        start: {
          line: 15,
          column: 19
        },
        end: {
          line: 15,
          column: 23
        }
      },
      "3": {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 18,
          column: 7
        }
      },
      "4": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 36
        }
      },
      "5": {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 19,
          column: 48
        }
      },
      "6": {
        start: {
          line: 25,
          column: 17
        },
        end: {
          line: 25,
          column: 33
        }
      },
      "7": {
        start: {
          line: 27,
          column: 0
        },
        end: {
          line: 27,
          column: 41
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 15
          },
          end: {
            line: 13,
            column: 16
          }
        },
        loc: {
          start: {
            line: 13,
            column: 50
          },
          end: {
            line: 20,
            column: 5
          }
        },
        line: 13
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 16,
            column: 6
          },
          end: {
            line: 18,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 16,
            column: 6
          },
          end: {
            line: 18,
            column: 7
          }
        }, {
          start: {
            line: 16,
            column: 6
          },
          end: {
            line: 18,
            column: 7
          }
        }],
        line: 16
      },
      "1": {
        loc: {
          start: {
            line: 16,
            column: 10
          },
          end: {
            line: 16,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 10
          },
          end: {
            line: 16,
            column: 22
          }
        }, {
          start: {
            line: 16,
            column: 26
          },
          end: {
            line: 16,
            column: 60
          }
        }],
        line: 16
      },
      "2": {
        loc: {
          start: {
            line: 19,
            column: 13
          },
          end: {
            line: 19,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 13
          },
          end: {
            line: 19,
            column: 19
          }
        }, {
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 48
          }
        }],
        line: 19
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { compose } from '../utils/func';
import delay from '../hoc/delay';
import inputable from '../Form/inputable';
import inputBorder from '../hoc/inputBorder';
import Component from './Textarea';
import { inputClass } from '../Input/styles';
var input = (cov_1theuk0zai.s[0]++, compose(inputable, inputBorder({
  className: function className(props) {
    cov_1theuk0zai.f[0]++;

    var _ref = (cov_1theuk0zai.s[1]++, props),
        value = _ref.value,
        renderFooter = _ref.renderFooter;

    var footer = (cov_1theuk0zai.s[2]++, null);
    cov_1theuk0zai.s[3]++;

    if ((cov_1theuk0zai.b[1][0]++, renderFooter) && (cov_1theuk0zai.b[1][1]++, typeof renderFooter === 'function')) {
      cov_1theuk0zai.b[0][0]++;
      cov_1theuk0zai.s[4]++;
      footer = renderFooter(value);
    } else {
      cov_1theuk0zai.b[0][1]++;
    }

    cov_1theuk0zai.s[5]++;
    return (cov_1theuk0zai.b[2][0]++, footer) && (cov_1theuk0zai.b[2][1]++, inputClass('with-footer'));
  }
}), delay(400)));
var Textarea = (cov_1theuk0zai.s[6]++, input(Component));
cov_1theuk0zai.s[7]++;
Textarea.displayName = 'ShineoutTextarea';
export default Textarea;